import {
	ENTITIES_ADD,
	ENTITIES_MUTATE,
	ENTITIES_REPLACE,
	ENTITIES_REMOVE,
} from '../constants/actionTypes';

export const addEntities = entities => ({
	type: ENTITIES_ADD,
	payload: entities,
});

/**
 *
 * @param string key (key of entity to mutate)
 * @param int id (id of entity to mutate)
 * @param string attribute (attribute in entity)
 * @param function fn (a function that mutates the attribute)
 */
export const mutateEntity = (key, id, attribute, fn) => {
	return {
		type: ENTITIES_MUTATE,
		payload: {
			key,
			id,
			attribute,
			fn,
		},
	};
};

export const replaceEntities = entities => ({
	type: ENTITIES_REPLACE,
	payload: entities,
});

export const removeEntities = (type, ids) => ({
	type: ENTITIES_REMOVE,
	payload: {
		type,
		ids,
	},
});



// WEBPACK FOOTER //
// ./src/actions/entities.js